import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { MessageSquare } from "lucide-react";

export default function ChatList() {
  const { user } = useAuth();
  const [threads, setThreads] = useState([]);
  useEffect(() => { api.get("/chat/threads").then(({ data }) => setThreads(data)); }, []);
  return (
    <div className="bg-slate-50 min-h-[calc(100vh-4rem)]">
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-10">
        <div className="hw-label text-blue-700">Conversations</div>
        <h1 className="hw-head text-4xl md:text-5xl font-black text-slate-900 mt-3">Chats</h1>
        {threads.length === 0 ? (
          <div className="hw-card p-10 mt-8 text-center text-slate-600">No conversations yet.</div>
        ) : (
          <div className="space-y-3 mt-8">
            {threads.map((t) => (
              <Link to={`/chats/${t.thread_id}`} key={t.thread_id} className="hw-card p-5 flex items-center gap-4 hover:hw-shadow-pop transition-all hover:-translate-y-0.5 block" data-testid={`thread-${t.thread_id}`}>
                <div className="w-10 h-10 bg-slate-900 grid place-items-center rounded-sm"><MessageSquare className="w-4 h-4 text-emerald-400" /></div>
                <div className="flex-1">
                  <div className="hw-head font-bold text-slate-900">{user?.role === "hotel_partner" ? t.customer_name : t.hotel_name}</div>
                  <div className="text-xs text-slate-500">{t.hotel_name}</div>
                </div>
                <span className="hw-label text-blue-700">Open →</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
